import React from 'react';
import propTypes from 'prop-types';

const ParagraphWithBg = ({ elClass, text}) => {

	return (
		<div className={`main-grid ${elClass}`}>
			<div className='main-grid__margin'></div>
			<div className='main-grid__body'>
				<div className={`${elClass}__text-container`} dangerouslySetInnerHTML={{__html: text}}>
				</div>
				<svg className={`${elClass}__bg-shape bg-shape`} width="324" height="324" viewBox="0 0 324 324" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path opacity="0.6" d="M324 324C145.059 324 -1.26815e-05 178.941 -2.8325e-05 3.05176e-05L324 2.1926e-06L324 324Z" fill="#E5D9AE"/>
				</svg>
			</div>
			<div className='main-grid__margin'></div>
		</div>
	)
}

export default ParagraphWithBg;

ParagraphWithBg.propTypes = {
	text: propTypes.string.isRequired,
	elClass: propTypes.string.isRequired,
};